import { render } from "./MediaText.vue?vue&type=template&id=66e6ecec&scoped=true"
import script from "./MediaText.vue?vue&type=script&lang=js"
export * from "./MediaText.vue?vue&type=script&lang=js"

import "./MediaText.vue?vue&type=style&index=0&id=66e6ecec&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e6ecec"]])

export default __exports__